import {Component} from '@angular/core';

@Component({
    selector: 'app-footer',
    standalone: true,
    template: ``,
        imports: []
})
export class AppFooterComponent {

    constructor() {
    }
}